<template>
  <el-card>
  <div slot="header">
    <slot name="header"></slot>
  </div>
  <el-row :gutter="10" v-for="propName in propertyNames" v-if="article[propName]" :key="propName">
    <el-col :span="4">{{ propName }}</el-col>
    <el-col :span="12">{{ output(propName) }}</el-col>
  </el-row>
  <h3> {{ output('header') }}</h3>
  <p>{{ output('body') }}</p>
  </el-card>
</template>

<script>
import moment from 'moment'

export default {
  props: ['article'],
  data () {
    return {
      propertyNames: [
        'created_date',
        'sent_date',
        'type',
        'recipient',
        'language'
      ]
    }
  },
  methods: {
    output (propName) {
      if (propName === 'created_date' || propName === 'sent_date') {
        return moment(this.article[propName]).format('lll')
      }
      return this.article[propName]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/news/Viewer.vue